import { Fragment } from "react";
import "./index.css";
function IosPageParisTest() {
  window.location.href = 'https://milocal-txd.web.app/test/ios-paris';
  return (
    <div className="content-page">
      <div className="ios-page">
        <div className="content">
          <img
            className="mb-2"
            src="../assets/img/paris/android/logo.svg"
            alt=""
          />
          <img src="../assets/img/paris/android/txt.svg" alt="" />
          <a
            className="btndownload"
            href="itms-services://?action=download-manifest&url=https://milocalapp.firebaseapp.com/assets/ios-paris-prueba/manifest.plist"
          >
            Descargar milocal iOS para test
          </a>
          <a
            className="btndownload"
            href="https://ux-cdn.cencosudx.io/milocal/txd/milocal-v.1.3.0-production-0.6.apk"
          >
            Descargar milocal Android para test
          </a>
        </div>
      </div>
      <img
        className="footer"
        src="../assets/img/paris/android/footer.svg"
        alt=""
      />
    </div>
  );
}

export default IosPageParisTest;
